module.exports = __webpack_public_path__ + "static/img/rysy.298b3ccb.png";